export default {
  SettlementsBrokerView: 'SettlementsBrokerView',
};
